import type { SyncHasMany } from "@ember-data/model";
import Model, { attr, hasMany } from "@ember-data/model";
import type HealthCentre from "./health-centre";

export default class HealthCentreTag extends Model {
  @hasMany("health-centre", { async: false, inverse: "healthCentreTags" })
  declare healthCentres: SyncHasMany<HealthCentre>;
  @attr("string") declare tagTitle: string;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "health-centre-tag": HealthCentreTag;
  }
}
